import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'SystemLogService',
    controller: 'ErrorLog'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GeItemById',
    'FindByConditions',
    'GetItemPagingList'  
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const ErrorLogApi = ZJApi.defineNewApi('ErrorLogApi', factory);

export default ErrorLogApi;